import { Download, Delete } from "@mui/icons-material";
import { TableRow, TableCell, IconButton } from "@mui/material";
import { IDocument } from "../../interfaces/IDocument";
import { IMIMEType } from "../../interfaces/IMIMEType";
import { getFetch } from "../../hooks/useFetch";
import { IOfferPositionCheckListItemDocument } from "../../interfaces/IProjectDocument";
import { IOfferPositionCheckListItem } from "../../interfaces/IOfferPositionCheckListItem";

interface IProps {
    currentDocument: IOfferPositionCheckListItemDocument;
    mimeTypeArray: IMIMEType[];
    deleteCheckListItemDocument: Function;
    documentTab?: boolean;
    checkListItem?: IOfferPositionCheckListItem;
}

export const OfferPositionCheckListItemDocumentRow: React.FC<IProps> = ({
    currentDocument,
    mimeTypeArray,
    deleteCheckListItemDocument,
    documentTab = false,
    checkListItem,
}) => {
    const base64Download = (doc: IDocument, mimeTypes: IMIMEType[]) => {
        const currentMimeType = mimeTypes.find((x) => x.id === doc.MIMEtype.id);
        if (doc.data && currentMimeType) {
            const byteCharacters = atob(doc.data);
            const byteNumbers = Array.from(byteCharacters, (char) => char.charCodeAt(0));
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: currentMimeType.MIMEtype });
            const blobUrl = URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.href = blobUrl;
            a.download = doc.file_name;
            a.click();
        }
    };

    const handleDownload = async () => {
        if (currentDocument.Document.data) {
            base64Download(currentDocument.Document, mimeTypeArray);
        } else {
            getFetch("/document/", currentDocument.Document.id, (fetchedDocument: IDocument) => {
                base64Download(fetchedDocument, mimeTypeArray);
            });
        }
    };

    return documentTab ? (
        <TableRow>
            <TableCell>{currentDocument.id}</TableCell>
            <TableCell>{currentDocument.Document.file_name}</TableCell>
            <TableCell>{checkListItem?.title}</TableCell>
            <TableCell>
                <IconButton title="Datei herunterladen" onClick={handleDownload}>
                    <Download />
                </IconButton>
                <IconButton title="Datei löschen" onClick={() => deleteCheckListItemDocument(currentDocument)}>
                    <Delete />
                </IconButton>
            </TableCell>
        </TableRow>
    ) : (
        <TableRow>
            <TableCell>{currentDocument.id}</TableCell>
            <TableCell>{currentDocument.Document.file_name}</TableCell>
            <TableCell>
                <IconButton title="Datei herunterladen" onClick={handleDownload}>
                    <Download />
                </IconButton>
                <IconButton title="Datei löschen" onClick={() => deleteCheckListItemDocument(currentDocument)}>
                    <Delete />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};
